import React, { useState, useEffect } from 'react';
import { useStore } from '../../context/store';

export default function FilterPills( props ) {
    const {
        state,
        dispatch,
    } = useStore();

    const pre = 'ygl-filter-pills';

    const setFilter = (option, value, e) => {
        if ( null !== value ) {
            dispatch({
                type: 'setFilter', 
                payload: {
                    field: option,
                    value: value,
                }
            })
            props.toggleParentActiveClass(e)
        } else {
            dispatch({ type: 'removeFilter', payload: option });
        }
    }

    if ( 'undefined' !== props.filter ) {
        const filter = props.filter;

        return (
            <div className={`ygl-filter ${pre}`}>
                <div className={`${pre}__title`} onClick={ e => props.toggleParentActiveClass(e) }>{filter.name}</div>

                <div className={`${pre}__dropdown`}>
                    <fieldset className={`${pre}__fieldset`}>
                        <legend className={`${pre}__legend`}>{filter.label}</legend>
 
                        <div className="pill-group">
                            {filter.options.map( (option, key) => {
                                const isChecked = 'undefined' !== typeof state.filters[ filter.field ] 
                                    ? state.filters[ filter.field ] == option.value
                                    : null === option.value;

                                return (
                                    <div className="pill-group__item" key={ key }>
                                        <input 
                                            type="radio" 
                                            id={`${filter.field}-${option.name}-${key}`} 
                                            name={filter.field} 
                                            value={option.value ?? ''}
                                            onChange={ e => setFilter( filter.field, option.value, e ) }
                                            checked={ isChecked }
                                        />

                                        <label htmlFor={`${filter.field}-${option.name}-${key}`}>{option.name}</label>
                                    </div>
                                )
                            })}
                        </div>
                    </fieldset>
                </div>
            </div>
        )
    }

    return '';
}